var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "store" }, [
      _c("div", { staticClass: "banxin" }, [
        _c("div", { staticStyle: { background: "#F5F5F5" } }, [
          _c("div", [
            _c("div", { staticClass: "shop" }, [
              _c("div", {}, [
                _c(
                  "div",
                  {
                    staticClass: "warp",
                    staticStyle: {
                      padding: "20px",
                      position: "relative",
                      background: "#fff",
                      "border-radius": "18px"
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "shopInfo-box",
                        staticStyle: {
                          display: "flex",
                          "justify-content": "space-between",
                          "align-items": "center"
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "shop1",
                            staticStyle: {
                              display: "flex",
                              "justify-content": "flex-start",
                              "align-items": "center"
                            }
                          },
                          [
                            _c("div", { staticClass: "shopLogo" }, [
                              _vm.shopLogo
                                ? _c("img", {
                                    attrs: { src: _vm.shopLogo, alt: "" }
                                  })
                                : _c("img", {
                                    attrs: {
                                      src: require("../../../assets/images/logo.png"),
                                      alt: ""
                                    }
                                  })
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "shopHeard" }, [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "justify-content": "left"
                                  }
                                },
                                [
                                  _c("div", [
                                    _c("h2", { staticClass: "shopName" }, [
                                      _vm._v(_vm._s(_vm.shopName))
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "guanzhu",
                                      style:
                                        _vm.collectData.ifCollect === 0
                                          ? ""
                                          : "background-color: rgba(255, 71, 71, 1);color: #fff;",
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.collect.apply(
                                            null,
                                            arguments
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.collectData.ifCollect === 0
                                            ? "关注"
                                            : "已关注"
                                        )
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "information" }, [
                                _c("span", { staticClass: "dizhi" }, [
                                  _c("i", {
                                    staticClass: "icon-positioning",
                                    staticStyle: {
                                      color: "#fb7600",
                                      "font-size": "20px",
                                      "margin-right": "5px"
                                    }
                                  }),
                                  _vm._v(
                                    "\n                          " +
                                      _vm._s(_vm.adressForm.shopAdress) +
                                      "\n                        "
                                  )
                                ])
                              ])
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _vm._m(0)
                      ]
                    )
                  ]
                )
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "warp" }, [
          _vm.isIndex
            ? _c(
                "div",
                [
                  _vm.shopId && _vm.platform == "b2b"
                    ? _c("shopHome", {
                        attrs: { terminal: 4, typeId: 3, shopId: _vm.shopId }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.shopId && _vm.platform == "b2c"
                    ? _c("shopHomeB2C", {
                        attrs: { terminal: 4, typeId: 3, shopId: _vm.shopId }
                      })
                    : _vm._e()
                ],
                1
              )
            : _vm.isShopClassifyList
            ? _c("div", [
                _c(
                  "div",
                  { staticClass: "content" },
                  [
                    _c(
                      "el-breadcrumb",
                      {
                        staticStyle: { "font-size": "16px" },
                        attrs: { "separator-class": "el-icon-arrow-right" }
                      },
                      _vm._l(_vm.breadList, function(items, index) {
                        return _c("el-breadcrumb-item", { key: index }, [
                          _c(
                            "span",
                            {
                              staticClass: "bread",
                              on: {
                                click: function($event) {
                                  return _vm.getClassifyProduct(
                                    items.classifyId
                                  )
                                }
                              }
                            },
                            [_vm._v(_vm._s(items.classifyName))]
                          )
                        ])
                      }),
                      1
                    ),
                    _vm._v(" "),
                    _vm.isClssfiy
                      ? _c(
                          "div",
                          {
                            staticStyle: {
                              background: "#ffffff",
                              "margin-bottom": "30px",
                              "margin-top": "20px"
                            }
                          },
                          [
                            _c("div", { staticClass: "classify" }, [
                              _c("div", { staticClass: "xiangguan" }, [
                                _vm._v("筛选")
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "fontB",
                                  class: _vm.sxIndex == "4" ? "active" : "",
                                  staticStyle: { "margin-right": "30px" },
                                  on: { click: _vm.tuijianProduct }
                                },
                                [_vm._v("推荐")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "fontB",
                                  class: _vm.sxIndex == "5" ? "active" : "",
                                  on: { click: _vm.shangxinProduct }
                                },
                                [_vm._v("上新")]
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "classify" }, [
                              _c("div", { staticClass: "xiangguan" }, [
                                _vm._v("排序")
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "default fontB",
                                  class: _vm.index == "1" ? "active" : "",
                                  on: {
                                    click: function($event) {
                                      return _vm.defaultSort()
                                    }
                                  }
                                },
                                [_vm._v("默认")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "prices fontB",
                                  class: _vm.index == "2" ? "active" : "",
                                  staticStyle: {
                                    display: "flex !important",
                                    "justify-content": "left !important"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.priceSort()
                                    }
                                  }
                                },
                                [
                                  _c("span", [_vm._v("价格")]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "arr" }, [
                                    _c("div", {
                                      staticClass: "up",
                                      class: _vm.type == 1 ? "low" : ""
                                    }),
                                    _vm._v(" "),
                                    _c("div", {
                                      staticClass: "down",
                                      class: _vm.type == 2 ? "high" : ""
                                    })
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "sales fontB",
                                  class: _vm.index == "3" ? "active" : "",
                                  on: {
                                    click: function($event) {
                                      return _vm.salesSort()
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                  销量\n                  "
                                  ),
                                  _c("img", {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.index !== "3",
                                        expression: "index !== '3'"
                                      }
                                    ],
                                    attrs: {
                                      src: require("../../../../static/image/reduce@2x.png"),
                                      alt: ""
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("img", {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          _vm.index == "3" && _vm.volume == 1,
                                        expression:
                                          "index == '3' && volume == 1"
                                      }
                                    ],
                                    attrs: {
                                      src: require("../../../../static/image/reduce2@2x.png"),
                                      alt: ""
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("img", {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          _vm.index == "3" && _vm.volume == 2,
                                        expression:
                                          "index == '3' && volume == 2"
                                      }
                                    ],
                                    attrs: {
                                      src: require("../../../../static/image/reduce1@2x.png"),
                                      alt: ""
                                    }
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "priceBox" }, [
                                _c("div", { staticClass: "pri fontB" }, [
                                  _vm._v("价格")
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "min" }, [
                                  _vm._v(
                                    "\n                    ¥\n                    "
                                  ),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.minMoney,
                                        expression: "minMoney"
                                      }
                                    ],
                                    attrs: { type: "number" },
                                    domProps: { value: _vm.minMoney },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.minMoney = $event.target.value
                                      }
                                    }
                                  })
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticStyle: { margin: "0 10px" } },
                                  [_vm._v("-")]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "max" }, [
                                  _vm._v(
                                    "\n                    ¥\n                    "
                                  ),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.maxMoney,
                                        expression: "maxMoney"
                                      }
                                    ],
                                    attrs: { type: "number" },
                                    domProps: { value: _vm.maxMoney },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.maxMoney = $event.target.value
                                      }
                                    }
                                  })
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "btn",
                                    on: { click: _vm.priceSearch }
                                  },
                                  [_vm._v("确定")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "clear",
                                    on: { click: _vm.clearMoney }
                                  },
                                  [_vm._v("清空")]
                                )
                              ])
                            ])
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", [
                      _vm.noProduct == false
                        ? _c(
                            "div",
                            {
                              staticStyle: {
                                background: "#ffffff",
                                "padding-bottom": "20px"
                              }
                            },
                            [
                              _c("ProductList", {
                                attrs: { productList: _vm.productList }
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                {},
                                [
                                  _vm.productList.length > 0 ||
                                  _vm.storeList.length > 0
                                    ? _c("el-pagination", {
                                        attrs: {
                                          "current-page": _vm.page,
                                          "page-size": _vm.pageSize,
                                          background: "",
                                          layout: "prev, pager, next",
                                          total: _vm.total
                                        },
                                        on: {
                                          "current-change":
                                            _vm.handleCurrentChange
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _c("div", { staticClass: "noproduct" }, [
                            _c("img", {
                              attrs: {
                                src: require("../../../../static/image/nothing@2x.png"),
                                alt: ""
                              }
                            }),
                            _vm._v(" "),
                            _c("p", { staticClass: "fs20 font-color-999" }, [
                              _vm._v("该分类没有商品～")
                            ])
                          ])
                    ])
                  ],
                  1
                )
              ])
            : _vm.isContact
            ? _c("div", [_c("contact")], 1)
            : _vm.isDossier
            ? _c("div", [_c("dossier")], 1)
            : _vm._e()
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          display: "flex",
          "justify-content": "flex-end",
          "align-items": "center"
        }
      },
      [
        _c("div", { staticClass: "shopBtn" }, [
          _c("img", {
            attrs: {
              src: require("../../../assets/images/b2c/kefu.png"),
              alt: "",
              srcset: ""
            }
          }),
          _vm._v(" "),
          _c("span", [_vm._v("联系客服")])
        ])
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-1b2d053e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-1b2d053e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/views/b2c/store/index.vue
// module id = null
// module chunks = 